module.exports = __webpack_public_path__ + "static/media/dropdown-icon.bce809b3.svg";